import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1462739d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#211F58]" }
const _hoisted_2 = { class: "tw-text-[16px] tw-leading-[130%] tw-font-semibold" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-justify-start tw-gap-[10px] tw-text-[#211F58]" }
const _hoisted_4 = { class: "tw-p-[25px]" }
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_6 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_7 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full tw-flex-wrap tw-gap-[25px]" }
const _hoisted_9 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_10 = { class: "input-container email-container tw-flex" }
const _hoisted_11 = { class: "input-container tw-grow tw-flex-1" }
const _hoisted_12 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_13 = { class: "input-container email-container tw-flex" }
const _hoisted_14 = { class: "input-container tw-grow tw-flex-1" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = { class: "tw-border-0 tw-border-t-[1px] tw-border-solid tw-border-[#EFF0F1] tw-p-[40px] tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-py-[40px] tw-text-[#211F58]" }
const _hoisted_17 = { class: "tw-text-[16px] tw-leading-[130%] tw-font-semibold" }
const _hoisted_18 = { class: "tw-flex tw-items-center tw-justify-start tw-gap-[10px] tw-text-[#211F58]" }
const _hoisted_19 = { class: "tw-p-[25px]" }
const _hoisted_20 = { class: "tw-flex tw-flex-col tw-gap-4 tw-text-[11px] tw-font-[400] tw-text-[#231F20]" }
const _hoisted_21 = { class: "tw-text-[14px] tw-font-semibold tw-text-[#211f58] tw-font-poppins" }
const _hoisted_22 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]" }
const _hoisted_23 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full tw-flex-wrap tw-gap-[25px]" }
const _hoisted_24 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_25 = { class: "input-container email-container tw-flex" }
const _hoisted_26 = { class: "input-container tw-grow tw-flex-1" }
const _hoisted_27 = { class: "tw-flex tw-items-center tw-justify-between tw-w-full" }
const _hoisted_28 = { class: "input-container email-container tw-flex" }
const _hoisted_29 = { class: "input-container tw-grow tw-flex-1" }
const _hoisted_30 = ["placeholder"]

import { getComponentUiText } from "@/utils/utilities";
import { reactive, ref, watch } from "vue";
import { BFormInput } from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import BaseInput from "../common/form/baseInput.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import CustomDescriptionContent from "../common/customDescriptionContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentDetailsVendorAssessmentModal',
  props: {
  modelValue: {
    type: Object,
    required: true,
  },
},
  emits: ["update:isDisabled", "update:modelValue"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


const autoTextarea = ref<HTMLTextAreaElement | null>(null);
const formModel = reactive({
  ...props.modelValue,
});



const rules = {
  internalDescription: {},
  internalNotes: {},
  assessmentDescription: {},
  assessmentNotes: {},
};

const $v = useVuelidate(rules, formModel as any);

watch(
  () => formModel,
  (value) => {
    emit("update:modelValue", value);
  },
  { deep: true },
);

const isCheckValid = async () => {
  await $v.value.$validate();
  if ($v.value.$invalid) return;
  return;
};

const autoResize = () => {
  if (autoTextarea.value) {
    autoTextarea.value.style.height = "auto"; // Reset height
    autoTextarea.value.style.height = autoTextarea.value.scrollHeight + "px"; // Set height based on content
  }
};

__expose({
  isCheckValid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-vendor-create-new-vendor-assessment-modal-label-assessment-details-internal-1",
            )) + " ", 1),
          _createElementVNode("span", null, [
            _createVNode(ButtonShowDuplicateAssessment, {
              "id-popover": 'popover-assessment-details-internal',
              "custom-class": 'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
              class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
              classes: `!tw-leading-none`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                        "app-vendor-create-new-vendor-assessment-modal-popover-title-assessment-details-internal-1",
                      )), 1),
                    _createVNode(CustomDescriptionContent, {
                      description: 
                      _unref(getComponentUiText)(
                        'app-vendor-create-new-vendor-assessment-modal-popover-description-assessment-details-internal-1',
                      )
                    ,
                      class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                    }, null, 8, ["description"])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
              "app-vendor-create-new-vendor-assessment-modal-label-description-assessment-details-internal-1",
            )), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BaseInput, {
            id: "internalDescription",
            modelValue: formModel.descInternal,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.descInternal) = $event)),
            container: 'tw-w-full ',
            "class-name": '!tw-items-center !tw-mt-[0px]',
            "class-name-label": 'tw-text-[#231F20]',
            label: 
              _unref(getComponentUiText)(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-description-1',
              )
            
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(BFormInput), {
                    modelValue: formModel.descInternal,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.descInternal) = $event)),
                    type: "text",
                    placeholder: 
                    _unref(getComponentUiText)(
                      'app-vendor-create-new-vendor-assessment-modal-label-internal-description-placeholder-1',
                    )
                  ,
                    class: _normalizeClass(['form-control input-base-form-input']),
                    "data-cy": "assessment-internal-description"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseInput, {
            id: "internalNotes",
            modelValue: formModel.notesInternal,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.notesInternal) = $event)),
            container: 'tw-w-full ',
            "class-name": '!tw-items-center !tw-mt-[0px]',
            "class-name-label": 'tw-text-[#231F20]',
            label: 
              _unref(getComponentUiText)(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-notes-1',
              )
            ,
            placeholder: 
              _unref(getComponentUiText)(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-notes-1',
              )
            
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("textarea", {
                    ref_key: "autoTextarea",
                    ref: autoTextarea,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.notesInternal) = $event)),
                    placeholder: 
                    _unref(getComponentUiText)(
                      'app-vendor-create-new-vendor-assessment-modal-label-internal-notes-placeholder-1',
                    )
                  ,
                    style: `outline-color : #EFF0F1`,
                    "data-cy": "assessment-internal-notes",
                    class: "tw-w-full auto-expand tw-min-h-[82px] tw-text-[13px] tw-font-normal tw-leading-none tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#eff0f180] tw-text-[#231F20]",
                    onInput: autoResize
                  }, null, 40, _hoisted_15), [
                    [_vModelText, formModel.notesInternal]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "placeholder"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-vendor-create-new-vendor-assessment-modal-label-assessment-details-vendor-1",
            )) + " ", 1),
          _createElementVNode("span", null, [
            _createVNode(ButtonShowDuplicateAssessment, {
              "id-popover": 'popover-assessment-details-vendor',
              "custom-class": 'tw-w-[max-content] md:tw-min-w-[500px] md:tw-max-w-[350px] lg:tw-max-w-[470px]',
              class: _normalizeClass(`!tw-p-0 tw-leading-[16px]`),
              classes: `!tw-leading-none`
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(getComponentUiText)(
                        "app-vendor-create-new-vendor-assessment-modal-popover-title-assessment-details-vendor-1",
                      )), 1),
                    _createVNode(CustomDescriptionContent, {
                      description: 
                      _unref(getComponentUiText)(
                        'app-vendor-create-new-vendor-assessment-modal-popover-description-assessment-details-vendor-1',
                      )
                    ,
                      class: _normalizeClass(`!tw-p-0 tw-text-[13px] tw-text-[#878787]`)
                    }, null, 8, ["description"])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(getComponentUiText)(
              "app-vendor-create-new-vendor-assessment-modal-label-description-assessment-details-vendor-1",
            )), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(BaseInput, {
            id: "assessmentDescription",
            modelValue: formModel.descExternal,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formModel.descExternal) = $event)),
            container: 'tw-w-full ',
            "class-name": '!tw-items-center !tw-mt-[0px]',
            "class-name-label": 'tw-text-[#231F20]',
            label: 
              _unref(getComponentUiText)(
                'app-vendor-create-new-vendor-assessment-modal-label-assessment-description-1',
              )
            ,
            placeholder: 
              _unref(getComponentUiText)(
                'app-vendor-create-new-vendor-assessment-modal-label-internal-description-placeholder-1',
              )
            
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(BFormInput), {
                    modelValue: formModel.descExternal,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.descExternal) = $event)),
                    type: "text",
                    "data-cy": "assessment-external-description",
                    placeholder: 
                    _unref(getComponentUiText)(
                      'app-vendor-create-new-vendor-assessment-modal-label-internal-description-placeholder-1',
                    )
                  ,
                    class: _normalizeClass(['form-control input-base-form-input'])
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(BaseInput, {
            id: "assessmentNotes",
            modelValue: formModel.notesExternal,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formModel.notesExternal) = $event)),
            container: 'tw-w-full ',
            "class-name-label": 'tw-text-[#231F20]',
            "class-name": '!tw-items-center !tw-mt-[0px]',
            label: 
              _unref(getComponentUiText)(
                'app-vendor-create-new-vendor-assessment-modal-label-assessment-instructions-1',
              )
            ,
            placeholder: 'Assessment notes'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("textarea", {
                    ref_key: "autoTextarea",
                    ref: autoTextarea,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formModel.notesExternal) = $event)),
                    "data-cy": "assessment-external-notes",
                    placeholder: 
                    _unref(getComponentUiText)(
                      'app-vendor-create-new-vendor-assessment-modal-instructions-for-vendor-placeholder-1',
                    )
                  ,
                    style: `outline-color : #EFF0F1`,
                    class: "tw-w-full auto-expand tw-min-h-[82px] tw-text-[13px] tw-font-normal tw-leading-none tw-px-5 tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#eff0f180] tw-text-[#231F20]",
                    onInput: autoResize
                  }, null, 40, _hoisted_30), [
                    [_vModelText, formModel.notesExternal]
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label"])
        ])
      ])
    ])
  ]))
}
}

})